<template>
    <div class="insights">
        <span class="title">{{ $translate('ai_insights') }}</span>

        <span v-if="insights.length" class="insights-counter">
            {{ insights.length }}
        </span>

        <div v-if="insights.length" class="insights-container">
            <div v-for="insight in insights" :key="insight._id" class="insight">
                <img src="/static/svg/chloe_icon.svg" alt="" class="avatar-image" />

                <div class="insight-body">
                    <div
                        v-if="insight.contentLanguageKey === 'FRAGMENTED_INSIGHT'"
                        class="text"
                        v-html="
                            $translate(
                                'fragmented_insight',
                                !!insight.valueString ? parseInt(insight.valueString) : 15
                            )
                        "
                    ></div>
                    <div
                        v-else
                        class="text"
                        v-html="
                            $translate(
                                insight.contentLanguageKey,
                                $uiUtils.formatHourSinceFertilization(...insight.contentParamValues)
                            )
                        "
                    ></div>

                    <span v-if="insight.atHour" class="time">
                        {{ getAtHourText(insight.atHour) }}
                    </span>
                </div>
            </div>
        </div>

        <div v-else class="placeholder">
            {{
                $translate('insights_about_this_embryo_will_appear_here_according_to_its_progress')
            }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'Insights',
    props: {
        insights: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        getAtHourText(atHour) {
            return this.$translate('hour_x', this.$uiUtils.formatHourSinceFertilization(atHour))
        }
    }
}
</script>

<style lang="scss" scoped>
.insights {
    position: relative;
    padding: 1.5rem 1rem 0 1rem;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    background-color: $dark-3;

    .title {
        color: $light;
        margin-bottom: 1rem;
    }

    .insights-counter {
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 50%;
        position: absolute;
        right: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10pt;
        font-weight: 600;
        color: $light-3;
        background-color: $orange;
    }

    .insights-container {
        display: flex;
        flex-direction: column-reverse;
        overflow-y: auto;

        .insight {
            display: flex;
            padding-bottom: 0.75rem;
            margin-bottom: 0.75rem;

            &:not(:nth-child(1)) {
                border-bottom: $border-narrow-dark-dashed;
            }

            .avatar-image {
                height: 2.25rem;
                width: 2.25rem;
                margin-right: 1rem;
            }

            .insight-body {
                display: flex;
                flex-direction: column;

                .time {
                    font-size: 10pt;
                    color: $light;
                    margin-top: 0.25rem;
                }
            }
        }
    }

    .placeholder {
        padding: 0 0.5rem;
    }
}
</style>

